import React, { useContext, useState } from 'react';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import MuiCheckBox from '../../../app/common/ui/MuiCheckBox';
import { toggleItemSelection } from '../../booking/BookingTools';
import { DbxContext } from '../../../services/DbxContext';

const ExperienceCard = ({category, vulnerabilities, selected, onChange}) => {
    
    const handleChange = (id, checked) => {
        onChange({id, checked, source: vulnerabilities});
    }
    
    return <div style={{marginTop: '1rem'}}>
        <Typography variant="button" color="initial">{category}</Typography>
        <div>
            {
                vulnerabilities.map(v => {
                    const checked = selected.findIndex(item => item.id === v.id) >= 0;
                    return <MuiCheckBox 
                        key={v.id}
                        id={v.id} 
                        value={checked}  
                        description={v.description}
                        onChange={handleChange}
                        />
                })
            }
        </div>
    </div>
}

const MemberExperience = ({ experience, onChange }) => {
    const cache = useContext(DbxContext);
    const [categories] = useState(cache.read('vulnerability_categories') || []);

    const handleChange = ({id, checked, source}) => {
        onChange({
            experience: toggleItemSelection({selected: experience, source, id, checked})
        });
    }

    return <Paper style={{marginTop: '1rem', padding: '1rem'}}>
        <Typography variant="h6" color="initial">Your Intermediary Experience</Typography>
        <Typography variant="subtitle2" color="initial">Tick any vulnerabilities that you have experience of working with</Typography>
        {
            categories.filter(cat => cat.name !== 'Unknown').map(cat => {

                return <ExperienceCard 
                    key={cat.id}
                    category={cat.name}
                    vulnerabilities={cache.read(cat.id) || []}
                    selected={experience}
                    onChange={handleChange}
                />
            })
        }
    </Paper>


}


export { ExperienceCard, MemberExperience }